<template>
    <div class="cargo_station_info">
        <div class="btn-list">
            <el-button class='btn bigData-btn-csi-refresh' type="text" :loading="loading" @click="handleSearch"><i class="el-icon-refresh icon"></i>刷新</el-button>
            <el-button class='btn bigData-btn-csi-add' type="text" @click="handleAdd"><i class="el-icon-circle-plus-outline icon"></i>新增</el-button>
            <el-button class='btn bigData-btn-csi-on' type="text" :loading="enableLoading" @click="handleBatch('enable')"><i class="el-icon-circle-check icon"></i>启用</el-button>
            <el-button class='btn bigData-btn-csi-off' type="text" :loading="disableLoading" @click="handleBatch('disable')"><i class="el-icon-circle-close icon"></i>停用</el-button>
            <!-- <el-button class='btn' type="text" @click="handleSearch"><i class="el-icon-download icon"></i>导出</el-button> -->
            <!-- <el-button class='btn' type="text" :loading="deleteLoading" @click="handleDelete"><i class="el-icon-delete icon"></i>删除</el-button> -->
        </div>
        <div class="cargo_station_info-table">
            <el-table v-loading="loading" :data="tableData" style="width: 100%" @row-dblclick="handleDblclick" @selection-change="handleSelectStation" @expand-change="handleExpand">
                <el-table-column type="selection"></el-table-column>
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-table v-loading="childrenLoading" :data="props.row.children" style="width: 100%" @row-dblclick="handleEditContacts">
                            <el-table-column label="联系人编码" prop="contactsCode" show-overflow-tooltip></el-table-column>
                            <el-table-column label="姓名" prop="contactsName" show-overflow-tooltip></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" show-overflow-tooltip></el-table-column>
                            <el-table-column label="手机号码" prop="contactsMobile" show-overflow-tooltip></el-table-column>
                            <el-table-column label="状态" prop="enableFlagText"></el-table-column>
                            <el-table-column label="MIP账号" prop="mipAccount" show-overflow-tooltip></el-table-column>
                            <el-table-column label="创建人" prop="createUserName" show-overflow-tooltip></el-table-column>
                            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip :width="150"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="160">
                                <template slot-scope="scope">
                                    <el-button @click="handleBatchContact(scope.row, 'enable')" type="text" size="small">启用</el-button>
                                    <el-button @click="handleBatchContact(scope.row, 'disable')" type="text" size="small">停用</el-button>
                                    <el-button @click="handleEditContacts(scope.row)" type="text" size="small">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <div>{{ props.children[0].idCard }}</div> -->
                    </template>
                </el-table-column>
                <el-table-column label="货站编码" prop="stationCode" show-overflow-tooltip></el-table-column>
                <el-table-column label="企业名称" prop="companyName" show-overflow-tooltip></el-table-column>
                <el-table-column label="信用代码" prop="societyCreditCode" show-overflow-tooltip></el-table-column>
                <el-table-column label="货站地址" prop="stationAddress" show-overflow-tooltip></el-table-column>
                <el-table-column label="货站名称" prop="stationName" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" prop="enableFlagText"></el-table-column>
                <el-table-column label="创建人" prop="createUserName" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip :width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleAddContact(scope.row)" type="text" size="small">新增联系人</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="12" class="page-text">
                    <div>
                        已选<span class="text-color">{{selectedStations.length}}</span>项
                    </div>
                    <slot name="page-module-btn"></slot>
                </el-col>
                <el-col :span="12">
                    <m-page :current-page="page.pageNo" :pageData="pageConfig" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange"></m-page>
                </el-col>
            </el-row>
        </div>
        <operate-station-dialog ref="stationRef" @success="handleSearch" />
        <operate-contacts-dialog ref="contactsRef" :stationCode="currentStationCode" @success="handleContactSearch" />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { getStationInfos, getStationAllContacts, enableStation, disableStation, enableContact, disableContact } from '../../../../../../api/register/cargoStationInfo.js';
import mPage from '@/components/supplierPanel/mPage/Main';
import OperateStationDialog from './OperateStationDialog.vue';
import OperateContactsDialog from './OperateContactsDialog.vue';

// const TEMP_DATA = [
//     {
//         stationCode: '爱仕达无',
//         companyName: '惹我热无',
//         societyCreditCode: '水电费第三方收',
//         children: [
//             { contactsCode: '111', contactsName: '111-1', idCard: '111-1-1' },
//             { contactsCode: '222', contactsName: '222-2', idCard: '222-2-2' }
//         ]
//     },
//     {
//         stationCode: '爱仕达无',
//         companyName: '惹我热无',
//         societyCreditCode: '水电费第三方收',
//         children: [
//             { contactsCode: '111', contactsName: '111-1', idCard: '111-1-1' },
//             { contactsCode: '222', contactsName: '222-2', idCard: '222-2-2' }
//         ]
//     },
//     {
//         stationCode: '爱仕达无',
//         companyName: '惹我热无',
//         societyCreditCode: '水电费第三方收',
//         children: [
//             { contactsCode: '111', contactsName: '111-1', idCard: '111-1-1' },
//             { contactsCode: '222', contactsName: '222-2', idCard: '222-2-2' }
//         ]
//     },
//     {
//         stationCode: '爱仕达无',
//         companyName: '惹我热无',
//         societyCreditCode: '水电费第三方收',
//         children: [
//             { contactsCode: '111', contactsName: '111-1', idCard: '111-1-1' },
//             { contactsCode: '222', contactsName: '222-2', idCard: '222-2-2' }
//         ]
//     }
// ];
export default {
    name: 'cargoStationInfo',
    components: { mPage, OperateStationDialog, OperateContactsDialog },
    props: {
        activeCode: {
            type: String,
            default() {
                return ''
            },
        },
        code: {
            type: String,
            default() {
                return ''
            },
        },
    },
    data() {
        return {
            loading: false,
            childrenLoading: false,
            enableLoading: false,
            disableLoading: false,
            deleteLoading: false,
            // tableData: TEMP_DATA,
            tableData: [],
            selectedStations: [], // 已选货站信息数据
            currentStationCode: null,
            pageConfig: {
                layout: 'total, sizes, prev, pager, next, jumper',
                pageSize: 10
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,
            currentPage: 1
        };
    },
    computed: {
        ...mapState(['supplier']),
        supplierCode() {
            return this.supplier ? this.supplier.supplierCode : this.$route.query.supplierCode;
        }
    },
    methods: {
        handleSearch() {
            this.loading = true;
            getStationInfos({ ...this.page, supplierCode: this.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list.map(item => {
                        item.enableFlagText = +item.enableFlag === 1 ? '启用' : '停用';
                        item.children = [];
                        return item;
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => { this.loading = false; });
        },
        handleAdd() {
            this.$refs.stationRef.open();
        },
        handleAddContact(row) {
            this.currentStationCode = row.stationCode;
            this.$refs.contactsRef.open();
        },
        handleDblclick(row) {
            this.$refs.stationRef.open(row);
        },
        handleEditContacts(row) {
            this.$refs.contactsRef.open(row);
        },
        pageChange(page) {
            this.$emit('sensitive')
            this.page.pageNo = page;
            this.handleSearch();
        },
        sizeChange(size) {
            this.$emit('sensitive')
            this.page.pageNo = 1;
            this.page.pageSize = size;
            this.handleSearch();
        },
        handleSelectStation(data) {
            this.selectedStations = data;
        },
        handleExpand(row, expandedRows) {
            // console.log(row, expandedRows);
            const isExpanded = expandedRows.some(eRow => eRow.id === row.id);
            if (isExpanded) {
                this.handleContactSearch(row.stationCode);
            }
        },
        handleContactSearch(stationCode) {
            this.childrenLoading = true;
            getStationAllContacts({
                stationCode: stationCode,
                supplierCode: this.supplierCode
            }).then(res => {
                if (res && +res.code === 0) {
                    const expandedIndex = this.tableData.findIndex(item => item.stationCode === stationCode);
                    this.tableData[expandedIndex].children = res.data.map(item => {
                        item.enableFlagText = +item.enableFlag === 1 ? '启用' : '停用';
                        return item;
                    });
                }
            }).finally(() => { this.childrenLoading = false; });
        },
        batchValidate() {
            const obj = { valid: true, msg: '' };
            if (!this.selectedStations.length) {
                obj.valid = false;
                obj.msg = '请先勾选货站数据!';
            }
            return obj;
        },
        handleBatch(type) {
            const validResult = this.batchValidate();
            if (validResult.valid) {
                const operateObj = {
                    enable: { apiFunc: enableStation, msg: '货站信息已启用!', loading: 'enableLoading' },
                    disable: { apiFunc: disableStation, msg: '货站信息已停用!', loading: 'disableLoading' }
                };
                const ids = this.selectedStations.map(item => item.id);
                this[operateObj[type].loading] = true;
                operateObj[type].apiFunc(ids).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(operateObj[type].msg);
                        this.handleSearch();
                    }
                }).finally(() => { this[operateObj[type].loading] = false; });
            } else {
                this.$message.warning(validResult.msg);
            }
        },
        handleBatchContact(row, type) {
            const operateObj = {
                enable: { apiFunc: enableContact, msg: '货站联系人已启用!' },
                disable: { apiFunc: disableContact, msg: '货站联系人已停用!' }
            };
            this.childrenLoading = true;
            operateObj[type].apiFunc([row.id]).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(operateObj[type].msg);
                    this.handleContactSearch(row.stationCode);
                }
            }).finally(() => { this.childrenLoading = false; });
        }
        // handleDelete() {
        //     const validResult = this.batchValidate();
        //     if (validResult.valid) {
        //         const operateObj = { apiFunc: deleteStation, msg: '货站信息删除成功!', ids: this.selectedStations.map(item => item.id) };
        //         if (this.selectedContacts.length) {
        //             operateObj.apiFunc = deleteContact;
        //             operateObj.msg = '货站联系人删除成功!';
        //             operateObj.ids = this.selectedContacts.map(item => item.id);
        //         }
        //         this.$confirm('是否确定删除所选数据?', '提示', {
        //             confirmButtonText: '确定',
        //             cancelButtonText: '取消',
        //             type: 'warning'
        //         }).then(() => {
        //             this.deleteLoading = true;
        //             operateObj.apiFunc(operateObj.ids).then(res => {
        //                 if (res && +res.code === 0) {
        //                     this.$message.success(operateObj.msg);
        //                     if (this.selectedContacts.length) {
        //                         this.handleContactSearch(this.selectedContacts[0].stationCode);
        //                     } else {
        //                         this.handleSearch();
        //                     }
        //                 }
        //             }).finally(() => { this.deleteLoading = false; });
        //         }).catch(() => { });
        //     } else {
        //         this.$message.warning(validResult.msg);
        //     }
        // }
    },
    mounted() {
        this.handleSearch();
    },
    watch: {
        activeCode(val) {
            if (val === this.code) {
                this.handleSearch()
            }
        },
    },
};
</script>
<style lang="less">
.cargo_station_info {
    width: 100%;

    .btn-list {
        display: flex;
        align-items: center;
        height: 28px;
        background: #FFFBF2;
        border: 1px solid #FFECE3;
        border-radius: 0.5px;

        .btn {
            margin-left: 20px;
            font-size: 12px;
            color: #666;
        }

        .icon {
            margin-right: 5px;
        }
    }

    .cargo_station_info-table {
        margin-top: 15px;
    }

    .row-bg {
        margin-top: 10px;
    }

    .page-text {
        display: flex;

        & > div {
            margin-right: 10px;
            height: 28px;
            font-size: 12px;
            line-height: 28px;

            .text-color {
                display: inline-block;
                width: 30px;
                text-align: center;
                color: #00BCBF;
            }
        }
    }
    // .el-table__expanded-cell {
    //     padding-top: 0;
    // }
}
</style>